module.exports = __webpack_public_path__ + "static/media/stabmani.e4c16473.png";